<template>
    <section
        class="tw-bg-cover tw-bg-center tw-bg-no-repeat"
        :style="{
            backgroundImage: `url(${bannerImage})`,
        }">
        <div class="io-container tw-my-0 tw-py-32">
            <h1
                class="tw-text-center tw-text-4xl tw-text-white"
                v-html="page.title"></h1>
        </div>
    </section>
    <section>
        <div
            class="io-container"
            v-html="page.text"></div>
    </section>
</template>

<script setup lang="ts">
    import { useMedia } from '@/composables/useMedia';
    import { useAppStore } from '@/store/app';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();
    const $route = useRoute();
    const appStore = useAppStore();

    const page = computed(() => {
        return $route.name === 'TermsConditions' ? appStore.getTermsConditions : appStore.getPrivacyPolicy;
    });

    const bannerImage = computed(() => {
        return useMedia(page.value.image).large;
    });

    watchEffect(() => {
        document.title = $route.name === 'TermsConditions' ? t('policies.termsDocTitle') : t('policies.policiesDocTitle');
    });
</script>

<style scoped></style>
